// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FeedbackStateI {}

export interface FeedbackDataI {
  sessionId: string;
  userId: string;
  action: 'like' | 'dislike';
  botResponse: string;
  model: string;
  otherParameters?: Record<string, any>;
}

export const state: FeedbackStateI = {};
